import { observer } from 'mobx-react-lite'
import controller from '../controllers/user.controller'
import i from '../../../translations/i'
import PhoneInput from 'react-phone-input-2'
import '../../../layouts/style/phone.css'
import { Button, Checkbox, Input } from 'antd'
import { LockOutlined, MailOutlined, UserOutlined } from '@ant-design/icons'
import { config } from '../../../config/app'
import { Helmet } from 'react-helmet'
import { runInAction } from 'mobx'
import { AuthError, AuthField, AuthHead, AuthSwitch, PasswordStrength } from '../shell/AuthShell'

export const Register = observer(() => {

    const failed = controller.error !== ''
    const status = failed ? 'error' : undefined

    return(
        <>
            <Helmet>
                <title>{i.t('auth:title.register')}</title>
            </Helmet>

            <AuthHead title={i.t('authShell:register.title')} text={i.t('authShell:register.text')} />

            <form className="au-form" onSubmit={(e) => controller.register(e)}>
                <AuthError message={controller.error} />

                <AuthField label={i.t('auth:placeholder.name')}>
                    <Input
                        size="large"
                        autoComplete="name"
                        autoFocus
                        status={status}
                        prefix={<UserOutlined />}
                        placeholder={i.t('authShell:namePlaceholder')}
                        value={controller.dataRegister.name}
                        onChange={(e) => controller.onChangeRegister('name', e.target.value)}
                        required
                    />
                </AuthField>

                <div className="au-form__row">
                    <AuthField label={i.t('authShell:phone')}>
                        <PhoneInput
                            country={config.defaultCountry}
                            inputClass={failed ? 'error' : ''}
                            placeholder={i.t('auth:placeholder.phone')}
                            value={controller.dataRegister.phone}
                            onChange={(e) => controller.onChangeRegister('phone', e)}
                        />
                    </AuthField>
                    <AuthField label={i.t('auth:placeholder.email')}>
                        <Input
                            size="large"
                            type="email"
                            autoComplete="email"
                            status={status}
                            prefix={<MailOutlined />}
                            placeholder={i.t('authShell:emailPlaceholder')}
                            value={controller.dataRegister.email}
                            onChange={(e) => controller.onChangeRegister('email', e.target.value)}
                            required
                        />
                    </AuthField>
                </div>

                <div className="au-form__row">
                    <AuthField label={i.t('auth:placeholder.password')}>
                        <Input.Password
                            size="large"
                            autoComplete="new-password"
                            status={status}
                            prefix={<LockOutlined />}
                            placeholder={i.t('authShell:passwordPlaceholder')}
                            value={controller.dataRegister.password}
                            onChange={(e) => controller.onChangeRegister('password', e.target.value)}
                            required
                        />
                    </AuthField>
                    <AuthField label={i.t('auth:placeholder.confirmPassword')}>
                        <Input.Password
                            size="large"
                            autoComplete="new-password"
                            status={status}
                            prefix={<LockOutlined />}
                            placeholder={i.t('authShell:passwordPlaceholder')}
                            value={controller.dataRegister.confirmPassword}
                            onChange={(e) => controller.onChangeRegister('confirmPassword', e.target.value)}
                            required
                        />
                    </AuthField>
                </div>
                <PasswordStrength password={controller.dataRegister.password} />

                <Checkbox
                    className="au-legal"
                    checked={controller.legal}
                    onChange={(e: any) => runInAction(() => controller.legal = e.target.checked)}
                >
                    {i.t('auth:agreeWith')} <a href="https://saleskit.biz/legal" target="_blank" rel="noreferrer">{i.t('auth:termsLink')}</a> {i.t('auth:and')} <a href="https://saleskit.biz/contract" target="_blank" rel="noreferrer">{i.t('auth:offerLink')}</a>
                </Checkbox>

                <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    block
                    loading={controller.submitting}
                    disabled={failed || !controller.legal}
                >
                    {i.t('authShell:register.submit')}
                </Button>
            </form>

            <AuthSwitch text={i.t('authShell:register.haveAccount')} link={i.t('authShell:register.login')} href="/login" />
        </>
    )
})
